import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { maskFromBottom, textsFromBottom, textsFromLeft, effectCount } from './imports/animations.js';
gsap.registerPlugin(ScrollTrigger);
gsap.registerEffect(effectCount);


export default {
  methods: {
    playHomeAnimation: () => {
      const callback = () => {
        textsFromBottom();
        textsFromLeft();
      }

      maskFromBottom({
        callback: callback
      });
    },
    playAboutAnimation: () => {
      maskFromBottom({
        callback: textsFromBottom
      });
    },
    playSustainabilityAnimation: () => {
      maskFromBottom();
      textsFromBottom();
      textsFromLeft();
    },
    playContactAnimation: () => {
      maskFromBottom();
      textsFromBottom();
    },
  },
  mounted() {
    const fleetPage = document.querySelector('.page-fleet');

    if (fleetPage) {
      gsap.utils.toArray(".counter-value").forEach(element => {
        gsap.effects.count(element, {
          duration: 2,
          end: element.dataset.count,
          increment: element.dataset.countStep ?? 1
        });
      });

      gsap.to(".animation-width-hr", {
        width: '100%',
        duration: 4
      });

      maskFromBottom();
      textsFromLeft();
      textsFromBottom();
    }

    const lineAbout = document.querySelector('.line-about');

    if(lineAbout) {

      lineAbout
      // calc(850px + 950px + 100px)
    }
  }
}